import React, { useState, useEffect } from 'react';
import { SvgImage, Image, Button } from '../common';
import VideoObjectProps from './type';
import { VIDEO_PROVIDERS } from '../../constants';
import './styles.scss';

const VideoObject = ({
  id,
  thumbnailImageUrl,
  provider,
  title,
  description,
  autoPlay,
  containerTheme = 'white',
  container,
  eventHub,
  isLive,
  setVideoPlaying,
  triggeredVideo,
  closeVideo,
  setCloseVideo,
}: VideoObjectProps) => {
  const [player, setPlayer] = useState<any>(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const match = VIDEO_PROVIDERS.find((item) => item.name === provider);

    if (match) {
      match.component().then((module) => {
        // @ts-ignore
        setPlayer({
          // @ts-ignore
          config: match.config,
          component: module.default,
        });
      });
    }
  }, []);

  const focusPlayer = (event: any) => {
    event.target.h.focus();
  };

  const root = 'video-object';
  const classes = [
    root,
    container ? 'video-object--container' : '',
    eventHub ? 'video-object--event-hub' : '',
  ];
  if (containerTheme) {
    classes.push(`${root}--theme-${containerTheme}`);
  }
  if (triggeredVideo !== undefined) {
    classes.push(`${root}--homepage-header`);
  }

  const handlePlayTrigger = () => {
    setActive(true);

    if (setVideoPlaying !== undefined) {
      setVideoPlaying(true);
    }
  };

  const handleCloseVideoWidget = () => {
    setActive(false);

    if (setVideoPlaying) {
      setVideoPlaying(false);
    }
  };

  useEffect(() => {
    if (triggeredVideo) {
      handlePlayTrigger();
    }
  }, [triggeredVideo]);

  useEffect(() => {
    if (closeVideo) {
      handleCloseVideoWidget();

      if (setCloseVideo) {
        setCloseVideo(false);
      }
    }
  }, [closeVideo]);

  return (
    <div className={classes.join(' ')}>
      {!active && !autoPlay && (
        <div className="video-object__visual">
          {(isLive && triggeredVideo === undefined) && (
            <div className="video-object__live">Live</div>
          )}
          <Image url={thumbnailImageUrl} alt="video thumbnail" aspectRatio="16x9" widthSizes={['400', '800', '1600']} />

          <button className="video-object__trigger" onClick={handlePlayTrigger}>
            <span className="video-object__trigger-icon">
              Play
            </span>
          </button>
        </div>
      )}

      {player && (active || autoPlay) && (
        <div className="video-object__provider">
          {triggeredVideo !== undefined && (
            <div className="video-object__close">
              <Button
                type="button"
                icon={{
                  reference: '#icon-close',
                  title: 'icon-close',
                }}
                handleClick={handleCloseVideoWidget}
              />
            </div>
          )}

          {provider && (
            <player.component videoId={id} options={player.config} onReady={focusPlayer} />
          )}
        </div>
      )}

      {(title || description) && (
        <div className="video-object__details">
          <div className={`video-object__title video-object__title--${containerTheme}`}>
            <SvgImage title="Play video" reference={eventHub ? '#icon-play-large' : '#icon-video'} />
            {title}
          </div>

          <div className="video-object__description">{description}</div>
        </div>
      )}
    </div>
  );
};

export default VideoObject;
